import { render, staticRenderFns } from "./properties-block-text.vue?vue&type=template&id=19fec14c&scoped=true"
import script from "./properties-block-text.vue?vue&type=script&lang=js"
export * from "./properties-block-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fec14c",
  null
  
)

export default component.exports